<p>dev-jab works!</p>

<div class="p-4">
  <h3>Developer Testing Tools</h3>

  <div class="mt-4">
    <p-button
      label="Create Test Monthly Invoice"
      icon="pi pi-plus"
      severity="success"
      [loading]="generatingTestInvoice"
      (onClick)="createTestMonthlyInvoice()">
    </p-button>
  </div>

  <!-- Pull Tenant Data Testing Widget -->
  <div class="mt-5 border-top-1 surface-border pt-4">
    <h4>Pull Tenant Data (Raw Backend Response)</h4>

    <div class="grid">
      <div class="col-12 md:col-3">
        <div class="field">
          <label for="suite" class="block mb-2">Suite</label>
          <input
            id="suite"
            type="text"
            pInputText
            [(ngModel)]="pullTenantSuite"
            class="w-full"
            [disabled]="pullingTenant">
        </div>
      </div>

      <div class="col-12 md:col-3">
        <div class="field">
          <label for="account" class="block mb-2">Account</label>
          <input
            id="account"
            type="text"
            pInputText
            [(ngModel)]="pullTenantAccount"
            class="w-full"
            [disabled]="pullingTenant">
        </div>
      </div>

      <div class="col-12 md:col-3">
        <div class="field">
          <label for="location" class="block mb-2">Location (Auto-filled)</label>
          <input
            id="location"
            type="text"
            pInputText
            [(ngModel)]="pullTenantLocation"
            class="w-full"
            [disabled]="true"
            pTooltip="Location is automatically set from current session">
        </div>
      </div>

      <div class="col-12 md:col-3">
        <div class="field">
          <label class="block mb-2">&nbsp;</label>
          <p-button
            label="Pull Tenant Data"
            icon="pi pi-download"
            severity="info"
            [loading]="pullingTenant"
            (onClick)="pullTenantData()"
            class="w-full">
          </p-button>
        </div>
      </div>
    </div>

    <!-- Display Response -->
    <div *ngIf="pullTenantResponse || pullTenantError" class="mt-3">
      <div *ngIf="pullTenantError" class="p-3 border-1 border-red-500 border-round bg-red-50">
        <h5 class="text-red-700 mt-0">Error:</h5>
        <pre class="text-red-700 m-0">{{ pullTenantError }}</pre>
      </div>

      <div *ngIf="pullTenantResponse" class="p-3 border-1 surface-border border-round surface-ground">
        <div class="flex justify-content-between align-items-center mb-2">
          <h5 class="mt-0 mb-0">Raw Response Data:</h5>
          <p-button
            label="Copy JSON"
            icon="pi pi-copy"
            [text]="true"
            size="small"
            (onClick)="copyToClipboard(formatJSON(pullTenantResponse))">
          </p-button>
        </div>

        <div class="overflow-auto" style="max-height: 500px;">
          <pre class="m-0 text-sm">{{ formatJSON(pullTenantResponse) }}</pre>
        </div>

        <!-- Quick Summary -->
        <div class="mt-3 p-2 surface-100 border-round">
          <h6 class="mt-0 mb-2">Quick Summary:</h6>
          <div class="grid text-sm">
            <div class="col-6 md:col-3">
              <strong>Suite:</strong> {{ pullTenantResponse.suite }}
            </div>
            <div class="col-6 md:col-3">
              <strong>Account:</strong> {{ pullTenantResponse.accountnumber }}
            </div>
            <div class="col-6 md:col-3">
              <strong>Name:</strong> {{ pullTenantResponse.name }}
            </div>
            <div class="col-6 md:col-3">
              <strong>Contacts:</strong> {{ pullTenantResponse.contactInfo?.length || 0 }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
